// extracted by mini-css-extract-plugin
export var externalLink = "_er-0";
export var internalLinkLabel = "_er-1";